import { render, staticRenderFns } from "./PosSale.vue?vue&type=template&id=4a13e477&scoped=true"
import script from "./PosSale.vue?vue&type=script&lang=js"
export * from "./PosSale.vue?vue&type=script&lang=js"
import style0 from "./PosSale.vue?vue&type=style&index=0&id=4a13e477&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a13e477",
  null
  
)

export default component.exports